<script>
  import SvelteMarkdown from 'svelte-markdown';

  import Editor from './Editor.svelte';
  import Button from './Button.svelte';
  import Container from './Container.svelte';

  export let owner;
  export let metadata;

  let name;
  let signature;
  let callableSignature;
  let callableCode;
  let executionOutput;

  $: {
    name = metadata?.name || "";
    signature = metadata?.methods?.__call__[0];
    if (signature) {
      callableSignature = ""//signature.slice(1, signature.length-1).replaceAll(/[\'\"]+[^\'\""]*[\'\"]+/g, '').replaceAll(/ *= *[^,]*/g,'');
    }
    executionOutput = undefined;
  };
  $: callableCode = `${name} = await user.get(${owner == 'you' ? '' : '"'+owner+'"'})();\n\nconsole.log(await ${name}(${callableSignature}))\n`;

</script>

<h1>{name+signature}</h1>

<p>by: <span style={owner === 'You' ? "color: var(--primary);":""}>{owner == 'You' ? owner: "ephemeral_"+ owner}</span></p>

{#if metadata?.doc}
  <Container style="text-align: left; border-color: #333; border-style: solid; border-radius: 10px; border-width: 0.2px">
    <SvelteMarkdown source={metadata?.doc.replaceAll("\n    ", "\n")} />
  </Container>
{/if}
<Editor language={"js"} bind:data={callableCode} marginTop=10/>
{#if executionOutput}
  <div style='background-color:#333d;border-radius: 10px; font-family:monospace; padding:10px' >
    {#each executionOutput as [type, message]}
      <p style="text-align:left;font-size:14px;color:{type === 'log' ? '#eee' : '#d33'}">{message}</p>
    {/each}
  </div>
{/if}
<Button
  style="background-color:var(--primary);color:var(--background);" 
  on:click={async () => {
    executionOutput = [];
    let originalLog = console.log, originalError = console.error;
    console.log = (...args) => {executionOutput = [...executionOutput, ['log', args.map(x => (x && x._isTelekinesisObject) ? ('≈ '+ x._state.repr) : x).join('\n')]]; originalLog(...args)} 
    console.error = (...args) => {executionOutput = [...executionOutput, ['error', args.join('\n')]]; originalError(...args)} 
    try {
      let wrapper = window.eval("async () => {"+ callableCode + "}");
      await wrapper().catch(e => console.error(e));

    } finally {
      console.log = originalLog;
      console.error = originalError;
    }
  }}>Execute</Button>
<p style="color: #aaa;">Tip: you also copy-paste & run this code in your browser's JS console</p>